let redirect = (actionData) => {
    setTimeout(function () {
        window.location.href = actionData.url;
    }, actionData.delay)
};

export default redirect;
